import React, { useEffect, useRef } from 'react';

const CustomOverlayView = ({ map, google, position, content, onClose }) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    if (!map || !google || !position) return;

    class CustomOverlay extends google.maps.OverlayView {
      div = null;

      onAdd() {
        this.div = document.createElement('div');
        this.div.style.position = 'absolute';
        this.div.innerHTML = content;

        const panes = this.getPanes();
        panes.overlayMouseTarget.appendChild(this.div);

        const closeBtn = this.div.querySelector('.close-overlay');
if (closeBtn) {
  closeBtn.addEventListener('click', onClose);
}

      }

      draw() {
        const projection = this.getProjection();
        const point = projection.fromLatLngToDivPixel(position);
        if (point && this.div) {
          this.div.style.left = `${point.x}px`;
          this.div.style.top = `${point.y}px`;
        }
      }

      onRemove() {
        if (this.div && this.div.parentNode) {
          this.div.parentNode.removeChild(this.div);
          this.div = null;
        }
      }
    }

    const overlay = new CustomOverlay();
    overlay.setMap(map);
    overlayRef.current = overlay;

    return () => {
      overlay.setMap(null);
    };
  }, [map, google, position, content, onClose]);

  return null;
};

export default CustomOverlayView;
